.countdownContainer {
  h2 {
    margin-bottom: 0;
    small {

      font-size: 14px;
      color: #f00;
    }
    @media (max-width: 767px) {
      text-align:center;
    }
  }
}
.countdownWrapper {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin: 7px -8px;
  height: 4.5em;
  align-items: flex-start;
  @media (max-width: 767px) {
    justify-content: center;
    align-items: center;
  }
}

.timeSection {
  padding: 0px 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.time {
  margin: 0;
  font-size: 56px !important;
  font-weight: 800 !important;
  font-family: 'sofia-pro', sans-serif;
  line-height: 0.9em;
}

.timeText {
  font-size: 18px !important;
  @media (max-width: 767px) {
    text-align: center;
    display: block;
    margin-top: 5px;
  }
}

.style01 {
  .countdownWrapper {
    justify-content: center;
    margin: 0;
    height: auto !important;
    align-items: center;
    gap: 5px;

    .timeSection {
      background-color: #E01B1A;
      border-radius: 5px;
      color: #fff !important;
      padding: 2px 6px;

      .time {
        margin: 0;
        font-size: 16px !important;
        font-weight: 800 !important;
        font-family: 'sofia-pro', sans-serif;
        line-height: 9px;
      }

      small.timeText {
        font-size: 9px !important;
        font-weight: 400 !important;
        text-transform: uppercase !important;
      }
    }

    .timeSection1 {
      .time {
        color: #E01B1A;
        font-size: 16px !important;
      }
    }
  }

}